import React, { useContext, useEffect, useState } from 'react'
import { CamelCaseWithSpaces, capitaliseFirstWord, formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY, getTypeWatchDelay, isValidEmail, LogInSchoolID, origin, transformNameOfCol, typewatch } from '../../JS/Common';
import { ApiGetCall, ApiGetCDNData, ApiGetHeaders, ApiPostCall } from '../../JS/Connector';
import Pagination from 'react-js-pagination';
import CustomizationPopup from '../../Components/CustomizationPopup';
import AlertsComp from '../../Components/AlertsComp';
import { useNavigate } from 'react-router-dom';
import PageHead from '../../Components/PageHead';
import Tab from '../../Components/Tab';
import AlertPopup from '../../Components/AlertPopup';
import Popup from '../../Components/Popup';
import { CheckValidation } from '../../Components/Validations';
import { faFileInvoiceDollar, faHandHoldingDollar, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import useConfig from '../../Hooks/useConfig';

import CustomFontAwesomeIcon from '../../Components/CustomFontAwesomeIcon';
import { useStickyAction } from '../../Hooks';
function CoveragePurchased() {
    const { student, organization, student_number, student_first_name, parent, dcc_module_text,
        student_last_name, secondary_text, adminCallNode, manager_user, parent_manager } = useConfig();
    const navigate = useNavigate();
    const [allData, setAllData] = useState({
        SortbyFlag: 'desc',
        searchstringForCover: '',
        searchstringForUnCover: '',
        searchstringForExpired: '',
    })
    const [ParentalTabs, setParentalTabs] = useState({
        Coverage: "active",
        Uncovered: "",
        Expired: ""
    });
    const [loading, setLoading] = useState(false);
    const [Emailerror, setEmailerror] = useState('');
    const [Alerts, setAlerts] = useState("");
    const [PurchasedGridData, setPurchasedGridData] = useState([]);
    const [ActualEnrollment, setActualEnrollment] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const showPagination = PurchasedGridData.length > 0;
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const [SortbyKey, setSortbyKey] = useState(null);
    const [ApproveRejectModal, setApproveRejectModal] = useState(false);
    const [ApproveRejectAlert, setApproveRejectAlert] = useState(false);
    const [RefundPopup, setRefundPopup] = useState(false);
    const [effectExecuted, setEffectExecuted] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [ShowCreateBatchButton, setShowCreateBatchButton] = useState(false);
    const [StudentIdForRefund, setStudentIdForRefund] = useState('');
    const [studentnumflag, setstudentnumflag] = useState(2);
    const [oldstudentnum, setoldstudentnu] = useState('');
    const [ShowYesDiv, setShowYesDiv] = useState(false);
    const [studentDetails, setstudentDetails] = useState([]);
    const [radioBtnFlag, setradioBtnFlag] = useState(0);
    const [tempFlag, settempFlag] = useState(0);
    const [ApproveDescription, setApproveDescription] =
        useState(`This ${student} is currently not enrolled in your ${organization}. If you select 'Approve,' the ${student} will be added to your ${organization}, and the club will be assigned to them. If you select 'Don't Approve,' the ${student}'s enrollment will not be approved, and the payment will be refunded. Do you wish to proceed?`);
    const [studentData, setStudentData] = useState({
        studentnum: '',
        firstname: "",
        lastname: '',
        parentfirstname: '',
        parentlastname: '',
        phoneno: '',
        email: '',
        student_old_details: {}
    })
    const [allocatedEnrollmentID, setallocatedEnrollmentID] = useState("");
    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    const StateData = useSelector((state) => state.authData);
    useEffect(() => {
        if (!effectExecuted) {
            ApiGetHeaders(44, setColumnNames)
            setEffectExecuted(true);
        }
    }, [columnNames, effectExecuted]);
    useEffect(() => {
        if (ParentalTabs.Coverage == "active") {
            PurchasedData(1, allData.searchstringForCover || null, SortbyKey || null, false)
        } else if (ParentalTabs.Uncovered == "active") {
            PurchasedData(2, allData.searchstringForUnCover || null, SortbyKey || null, false)
        } else {
            PurchasedData(3, allData.searchstringForExpired || null, SortbyKey || null, false)
        }
    }, [currentPage, LimitForPagination])
    async function PurchasedData(flag, searchstring, sortbykey, toogleSort) {
        if (!searchstring) searchstring = null;
        if (sortbykey && toogleSort) allData.SortbyFlag = allData.SortbyFlag == "desc" ? "asc" : "desc";
        var joinedString = null;
        var newsortbykey = sortbykey;
        if (sortbykey == null) {
            newsortbykey = 'approve';
        }
        if (columnNames.length > 0) {
            joinedString = columnNames.join('~')
                .replace(/\bclub_name\b/g, 'plan_name')
                .replace(/\bclub_num\b/g, 'plan_num');
        }
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/plans/insurance/parental-coverage-purchased?flag=${flag}&schoolId=${LogInSchoolID}&search=${searchstring}&sortBy=${newsortbykey}&sortByOrder=${allData.SortbyFlag}&page=${currentPage}&limit=${LimitForPagination}&data=${joinedString}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    setPurchasedGridData(responseRs.data.length ? responseRs.data : [])
                    setActualEnrollment(responseRs.total)
                }
            });
        }, getTypeWatchDelay(searchstring, 500));
    }
    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "club_name": item?.plan_name || '-',
            "student_num": item?.student_num || '-',
            "paid_amount": `$${item.paid_amount || '0'}`,
            "purchased_at": formatDateToUsaMMDDYYYY(item.created_at) || '-',
            "club_num": item?.plan_num || '-',
            "contact_name": item?.contact_name || '-',
            "contact_email": item?.contact_email || '-',
            "estimated_enrollment": item?.estimated_enrollment || '-',
            "devices_not_leave_school": item?.devices_not_leave_school || '-',
            "grade": item.grade || '-',
            "email": item.email || '-',
            "student_name": item.student_name || '-',
            "fair_use_acknowledgement": item.policy_agree == 1 ? 'Yes' : 'No',
        };
        return contentMap[columnName] || null;
    }
    const handleSortClick = (item) => {
        if (item == "club_name") {
            item = "plan_name"
        } else if (item == "club_num") {
            item = "plan_num"
        }
        if (item !== 0) {
            if (ParentalTabs.Coverage == "active") {
                PurchasedData(1, allData.searchstringForCover, item, true)
            } else if (ParentalTabs.Uncovered == "active") {
                PurchasedData(2, allData.searchstringForUnCover, item, true)
            } else {
                PurchasedData(3, allData.searchstringForExpired, item, true)
            }
            setSortbyKey(item)
        }
    };
    async function GetStudentData(student_id) {
        setShowYesDiv(false);
        setradioBtnFlag(0)
        settempFlag(0)
        setApproveDescription(`This ${student} is currently not enrolled in your ${organization}. If you select 'Approve,' the ${student} will be added to your ${organization}, and the club will be assigned to them. If you select 'Don't Approve,' the ${student}'s enrollment will not be approved, and the payment will be refunded. Do you wish to proceed?`)
        setLoading(true);
        await ApiGetCall(`/students/by-id?userId=${student_id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                const parentNameParts = responseRs.msg.parent_guardian_name ? responseRs.msg.parent_guardian_name.split(' ') : [];
                const parentFirstName = parentNameParts[0] || "";
                const parentLastName = parentNameParts[1] || "";
                setLoading(false);
                setStudentData({
                    ...studentData,
                    studentnum: responseRs.msg.student_num.toUpperCase(),
                    firstname: capitaliseFirstWord(responseRs.msg.device_user_first_name),
                    lastname: capitaliseFirstWord(responseRs.msg.device_user_last_name),
                    parentfirstname: capitaliseFirstWord(parentFirstName),
                    parentlastname: capitaliseFirstWord(parentLastName),
                    phoneno: responseRs.msg.parent_phone_number || "",
                    email: responseRs.msg.parent_guardian_email,
                    student_old_details: responseRs.msg.student_old_details || {}
                });
                setoldstudentnu(responseRs.msg.student_num);
            }
        });
    }
    async function ApproveorRejectPurchasesCall(MassOrSingleApprove, ApproveRejectStatus, radioBtnFlag) {
        if (MassOrSingleApprove == 2) {
            var isFormValid = CheckValidation({ formID: 'ApproveStudent' });
            if (!isValidEmail(studentData.email)) {
                setEmailerror("*Invalid Email");
                isFormValid = false;
            } else {
                setEmailerror("");
            }
            if (!isFormValid) {
                return;
            }
        }
        setLoading(true)
        const studentId = selectedIds.length > 0 ? selectedIds[0] : null;
        var studentflag = studentnumflag;
        if (oldstudentnum == studentData.studentnum) {
            studentflag = 2;
        }
        var raw = JSON.stringify({
            studentIds: MassOrSingleApprove == 1 ? selectedIds.map((id) => ({ uuid: id })) : null,
            studentID: MassOrSingleApprove == 1 ? null : studentId,
            schoolId: LogInSchoolID,
            studentFirstName: studentData?.firstname,
            studentLastName: studentData?.lastname,
            parentFirstName: studentData?.parentfirstname,
            parentLastName: studentData?.parentlastname,
            parentContact: studentData?.phoneno,
            parentEmail: studentData?.email,
            approveFlag: MassOrSingleApprove,
            approveRejectStatus: ApproveRejectStatus,
            studentNumber: studentData.studentnum,
            studentNumberFlag: studentflag,
            allocatedEnrollmentId: allocatedEnrollmentID,
            verificationFlag: radioBtnFlag,
            oldStudentNumber: oldstudentnum
        });
        await ApiPostCall("/students/approve", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setShowCreateBatchButton(false);
                    if (ApproveRejectStatus == 2) {
                        setAlerts(<AlertsComp show={true} variant="danger" msg={"User rejected with the attached club."} />);
                        setTimeout(() => {
                            setApproveRejectModal(false);
                            setApproveRejectAlert(false);
                            if (ParentalTabs.Coverage == "active") {
                                PurchasedData(1, allData.searchstringForCover, SortbyKey, false)
                            } else if (ParentalTabs.Uncovered == "active") {
                                PurchasedData(2, allData.searchstringForUnCover, SortbyKey, false)
                            } else {
                                PurchasedData(3, allData.searchstringForExpired, SortbyKey, false)
                            }
                            setAlerts(<AlertsComp show={false} />);
                        }, 2500);
                    }
                    else {
                        setAlerts(<AlertsComp show={true} variant="success" msg={"User approved with the attached club successfully."} />);
                        setTimeout(() => {
                            setApproveRejectModal(false);
                            setApproveRejectAlert(false);
                            if (ParentalTabs.Coverage == "active") {
                                PurchasedData(1, allData.searchstringForCover || null, SortbyKey || null, false)
                            } else if (ParentalTabs.Uncovered == "active") {
                                PurchasedData(2, allData.searchstringForUnCover || null, SortbyKey || null, false)
                            } else {
                                PurchasedData(3, allData.searchstringForExpired || null, SortbyKey || null, false)
                            }
                            // navigate('/users');
                            setAlerts(<AlertsComp show={false} />);
                        }, 1500);
                    }
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }

    async function verifyStudentNum() {
        const validate = CheckValidation({ formID: 'ApproveStudent' });
        if (!validate) {
            return;
        }
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            studentNumber: studentData.studentnum
        });
        await ApiPostCall("/plans/insurance/verify-student-number", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setradioBtnFlag(responseRs.radio_btn_flag);
                    if (responseRs.radio_btn_flag == 0) {
                        setApproveDescription(`This user is already in the system. If you select 'Verify & Approve', the ${student}'s information will be updated. Are you sure you want to proceed?`)
                        setShowYesDiv(true);
                        setstudentDetails(responseRs.student_details);
                        settempFlag(1);
                        if (tempFlag == 1) {
                            ApproveorRejectPurchasesCall(2, 1, responseRs.radio_btn_flag);
                        }
                    } else if (responseRs.radio_btn_flag == 1) {
                        settempFlag(0);
                        setApproveDescription(`This ${student} already exists in the system and has an active club. Please choose another ${student}.`)
                        setShowYesDiv(false);
                        setAlerts(<AlertsComp show={true} variant="success" msg={responseRs.msg} />);
                        setTimeout(() => {
                            setAlerts(<AlertsComp show={false} />);
                        }, 1500);
                    } else if (responseRs.radio_btn_flag == 2) {
                        settempFlag(0);
                        setApproveDescription(`This ${student} is currently not enrolled in your ${organization}. If you select 'Approve,' the ${student} will be added to your ${organization}, and the club will be assigned to them. If you select 'Don't Approve,' the ${student}'s enrollment will not be approved, and the payment will be refunded. Do you wish to proceed?`)
                        setShowYesDiv(false);
                        ApproveorRejectPurchasesCall(2, 1, responseRs.radio_btn_flag);
                    } else if (responseRs.radio_btn_flag == 3) {
                        setShowYesDiv(false);
                        ApproveorRejectPurchasesCall(2, 1, responseRs.radio_btn_flag);
                    }
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="success" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
            }
        });
    }

    async function funcRefund() {
        setLoading(true);
        var raw = JSON.stringify({
            studentId: StudentIdForRefund,
            schoolId: LogInSchoolID,
        });
        await ApiPostCall("/plans/insurance/mark-as-refund", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Refund Successfully!"} />);
                    setTimeout(() => {
                        setRefundPopup(false);
                        if (ParentalTabs.Coverage == "active") {
                            PurchasedData(1, allData.searchstringForCover, SortbyKey, false)
                        } else if (ParentalTabs.Uncovered == "active") {
                            PurchasedData(2, allData.searchstringForUnCover, SortbyKey, false)
                        } else {
                            PurchasedData(3, allData.searchstringForExpired, SortbyKey, false)
                        }
                        setAlerts(<AlertsComp show={false} />);
                    }, 2500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2500);
                }
            }
        });
    }

    const handleCheckboxForApprove = (e, id) => {
        if (e.target.checked) {
            setSelectedIds(prevIds => {
                const newIds = [...prevIds, id];
                const allVisibleIds = PurchasedGridData.filter(item => ((item?.student_status == 2 && item?.refund_status == 0) || item.record_type == 1)).map(item => item?.student_id);
                const allVisibleSelected = allVisibleIds.every(visibleId => newIds.includes(visibleId));
                setIsAllSelected(allVisibleSelected);
                setShowCreateBatchButton(newIds.length > 0);
                return newIds;
            });
        } else {
            setSelectedIds(prevIds => {
                const newIds = prevIds.filter(item => item !== id);
                setIsAllSelected(false);
                setShowCreateBatchButton(newIds.length > 0);
                return newIds;
            });
        }
    };
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allVisibleIds = PurchasedGridData.filter(item => ((item?.student_status == 2 && item?.refund_status == 0) || item.record_type == 1)).map(item => item?.student_id);
            setSelectedIds(allVisibleIds);
            setShowCreateBatchButton(true);
        } else {
            setSelectedIds([]);
            setShowCreateBatchButton(false);
        }
        setIsAllSelected(e.target.checked);
    };
    const handleApproveButtonClick = (id) => {
        setSelectedIds(prevIds => {
            if (!prevIds.includes(id)) {
                return [...prevIds, id];
            }
            return prevIds;
        });
        setShowCreateBatchButton(true);
        setApproveRejectModal(true);
    };
    function handleSearchChange(e) {
        if (ParentalTabs.Coverage == "active") {
            setCurrentPage(1);
            PurchasedData(1, e.target.value, null, false);
            setAllData({ ...allData, searchstringForCover: e.target.value });
        } else if (ParentalTabs.Uncovered == "active") {
            setCurrentPage(1);
            PurchasedData(2, e.target.value, null, false);
            setAllData({ ...allData, searchstringForUnCover: e.target.value });
        } else {
            setCurrentPage(1);
            PurchasedData(3, e.target.value, null, false);
            setAllData({ ...allData, searchstringForExpired: e.target.value });
        }
    }
    function handleTabClick(tabType) {
        if (tabType == "coverage") {
            PurchasedData(1, null, null, false);
            setParentalTabs({ ...ParentalTabs, Coverage: "active", Uncovered: "", Expired: "" });
            setCurrentPage(1);
            setSelectedIds([]);
            setShowCreateBatchButton(false);
            setIsAllSelected(false)
        } else if (tabType == "uncovered") {
            PurchasedData(2, null, null, false);
            setParentalTabs({ ...ParentalTabs, Coverage: "", Uncovered: "active", Expired: "" });
            setCurrentPage(1);
            setSelectedIds([]);
            setShowCreateBatchButton(false);
            setIsAllSelected(false)
        } else if (tabType == "expired") {
            PurchasedData(3, null, null, false);
            setParentalTabs({ ...ParentalTabs, Coverage: "", Uncovered: "", Expired: "active" });
            setCurrentPage(1);
            setSelectedIds([]);
            setShowCreateBatchButton(false);
            setIsAllSelected(false)
        }
    }
    const modalbody = (
        <form id="ApproveStudent" className="parent">
            {studentData?.student_old_details && Object.keys(studentData.student_old_details).length > 0 && <div className={`p-3 row greyBox mx-0`}>
                <div className="col-12 pb-2"><strong>Current {student} information stored in rocket</strong></div>
                <div className='col-md-6'>
                    {student} First Name : <label className='fw-600'>{studentData.student_old_details.device_user_first_name || '-'}</label>
                </div>
                <div className='col-md-6'>
                    {student} Last Name : <label className='fw-600'>{studentData.student_old_details.device_user_last_name || '-'}</label>
                </div>
                <div className='col-md-6 pt-2'>
                    {parent_manager} First Name : <label className='fw-600'>{studentData.student_old_details.parent_guardian_name?.split(' ')[0] || '-'}</label>
                </div>
                <div className='col-md-6 pt-2'>
                    {parent_manager} Last Name : <label className='fw-600'>{studentData.student_old_details.parent_guardian_name?.split(' ')[1] || '-'}</label>
                </div>
                <div className='col-md-6 pt-2'>
                    {parent_manager} Phone # : <label className='fw-600'>{studentData.student_old_details.parent_phone_number || '-'}</label>
                </div>
                <div className='col-md-6 pt-2'>
                    {parent_manager} Email : <label className='fw-600'>{studentData.student_old_details.parent_guardian_email || '-'}</label>
                </div>
            </div>}

            <div className="row">
                {studentData?.student_old_details && Object.keys(studentData.student_old_details).length > 0 &&
                    <div className="col-12 pt-3">
                        <strong>New information submitted by {manager_user}</strong>
                    </div>
                }
                <div className="col-md-4 py-2">
                    <div className='col-12 text-start px-1 pb-1'>{student} No. *</div>
                    <input className="form-control" autoComplete="off" type="text" name="studentnum"
                        required value={studentData?.studentnum}
                        onChange={(e) => { setstudentnumflag(1); setStudentData({ ...studentData, studentnum: e.target.value.toUpperCase() }) }} />
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                </div>
            </div>
            <div className='row'>
                <div className="col-md-4 py-2">
                    <div className='col-12 text-start px-1 pb-'>{student} First Name *</div>
                    <input className="form-control" required autoComplete="off" type="text" name="StudentFirstName" value={studentData.firstname} onChange={(e) => { setStudentData({ ...studentData, firstname: capitaliseFirstWord(e.target.value) }) }} />
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                </div>
                <div className="col-md-4 py-2">
                    <div className='col-12 text-start px-1 pb-1'>{student} Last Name *</div>
                    <input className="form-control" required autoComplete="off" type="text" name="StudentLastName" value={studentData.lastname} onChange={(e) => { setStudentData({ ...studentData, lastname: capitaliseFirstWord(e.target.value) }) }} />
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                </div>
                <div className="col-md-4 py-2">
                    <div className='col-12 text-start px-1 pb-1'>{parent} First Name *</div>
                    <input className="form-control" required autoComplete="off" type="text" name="ParentFirstName" value={studentData.parentfirstname} onChange={(e) => { setStudentData({ ...studentData, parentfirstname: capitaliseFirstWord(e.target.value) }) }} />
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                </div>
                <div className="col-md-4 py-2">
                    <div className='col-12 text-start px-1 pb-1'>{parent} Last Name *</div>
                    <input className="form-control" required autoComplete="off" type="text" name="ParentLastName" value={studentData.parentlastname} onChange={(e) => { setStudentData({ ...studentData, parentlastname: capitaliseFirstWord(e.target.value) }) }} />
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                </div>
                <div className="col-md-4 py-2">
                    <div className='col-12 text-start px-1 pb-1'>{parent} Phone </div>
                    <input className="form-control" autoComplete="off" type="text" name="ParentContact" value={studentData.phoneno} onChange={(e) => {
                        const value = e.target.value;

                        if (/^[0-9]*$/.test(value)) {
                            setStudentData(prev => ({
                                ...prev,
                                phoneno: value
                            }));
                        }
                    }} />
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                </div>
                <div className="col-md-4 py-2">
                    <div className='col-12 text-start px-1 pb-1'>{parent} Email *</div>
                    <input className="form-control" autoComplete="off" type="text" name="ParentEmail" value={studentData.email} onChange={(e) => { setStudentData({ ...studentData, email: e.target.value }) }} />
                    <span className="Emailinvalid">{Emailerror}</span>
                </div>
            </div>
            <div className='py-4 '>
                <label className='redText fw-600 text-center'>{ApproveDescription}</label>
                {ShowYesDiv &&
                    <>
                        <b className='pt-3'>*This is Existing User Details.</b>
                        <div className='row mt-1'>
                            <div className='col-md-6'>
                                {student} No. :&nbsp;{studentDetails?.student_num || '-'}
                            </div>
                            <div className='col-md-6'>
                                First Name :&nbsp;{studentDetails?.device_user_first_name || '-'}
                            </div>
                            <div className='col-md-6'>
                                Last Name :&nbsp;{studentDetails?.device_user_last_name || '-'}
                            </div>
                            <div className='col-md-6'>
                                {parent} Name :&nbsp;{studentDetails?.parent_guardian_name || '-'}
                            </div>
                            <div className='col-md-6'>
                                {parent} Email :&nbsp;{studentDetails?.parent_guardian_email || '-'}
                            </div>
                            <div className='col-md-6'>
                                {parent} Contact :&nbsp;{studentDetails?.parent_phone_number || '-'}
                            </div>
                        </div>
                    </>
                }
            </div>

        </form>
    )
    async function ExportPurchasedData() {
        setLoading(true);
        await ApiGetCall(`${adminCallNode}/plans/insurance/export-purchase-data?schoolId=${LogInSchoolID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.length > 0) {
                    DownloadCsv(responseRs);
                } else {
                    DownloadCsv([]);
                }
                setLoading(false);
            }
        });
    }
    const DownloadCsv = (CsvData) => {
        const csvContent = [];
        const PurchaseMap = [];
        CsvData?.forEach((item) => {
            const rowData = {
                'Club Name': item.plan_name.replace(/[,\r\n.]/g, ' '),
                [student_number]: item.student_num,
                [student_first_name]: item.student_first_name,
                [student_last_name]: item.student_last_name,
                'Purchase/Entry Date': item.purchase_date ? formatDateToMMDDYYYY(item.purchase_date) : '-',
                'Acknowledgement of Fair Use Policy': item.acknowledgement_of_policy ? 'Yes' : 'No',
                'Enrolled': item.enrolled,
            };
            PurchaseMap.push(rowData);
        });

        if (PurchaseMap.length > 0) {
            const headers = ['Club Name',
                student_number,
                student_first_name,
                student_last_name,
                'Purchase/Entry Date', 'Acknowledgement of Fair Use Policy', 'Enrolled'];
            csvContent.push(headers);
            PurchaseMap.forEach((rowData) => {
                const values = Object.values(rowData);
                csvContent.push(values);
            });
            csvContent.push([]);
            const csvString = csvContent.map((row) => row.join(',')).join('\n');
            const blob = new Blob([csvString], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${dcc_module_text} Data.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            setAlerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
            setTimeout(() => {
                setAlerts(<AlertsComp show={false} />);
            }, 2500);
        }
    };

    function downloadreceipt(receipt_url) {
        if (receipt_url) {
            window.open(receipt_url, "_blank")
        } else {
            setAlerts(<AlertsComp show={true} variant="danger" msg={"No Receipt Found"} />);
            setTimeout(() => {
                setAlerts(<AlertsComp show={false} />);
            }, 2500);
        }
    }
    const saveAs = (pdfdoc) => {
        ApiGetCDNData("/" + pdfdoc, StateData?.Schoolnumber).then((blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        });
    };
    return (
        <React.Fragment>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Purchases"} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />
            <div className="GridBox mt-2 p-3">
                <div className="row px-0 pb-2">
                    <div className='col-md-9'>
                        <ul className="nav nav-tabs">
                            <Tab isActive={ParentalTabs.Coverage == 'active'}
                                label="Enrolled" onClick={() => handleTabClick('coverage')} col={'col-md-3'} />
                            <Tab isActive={ParentalTabs.Uncovered == 'active'}
                                label="Not Enrolled" onClick={() => handleTabClick('uncovered')} col={'col-md-3'} />
                            <Tab isActive={ParentalTabs.Expired == 'active'}
                                label="Expired" onClick={() => handleTabClick('expired')} col={'col-md-3'} />
                        </ul>
                    </div>
                    <div className="col-md-3 text-end px-0 mx-0">
                        <label className="BorderBtn text-end  mt-0"
                            onClick={(e) => ExportPurchasedData()}
                        >
                            <img src="/images/ExportInventory.svg" className="cursor-pointer pe-2"
                                height="15px" />
                            Export Data
                        </label>

                    </div>
                    <div className='col-12 text-end'>
                        {ShowCreateBatchButton == true && (
                            <label className="BorderBtn text-end  mt-0"
                                onClick={(e) => setApproveRejectAlert(true)}
                            >
                                <img src="images/TransactionIcon.svg" className="cursor-pointer pe-2" title="Approve User"
                                    height="15px" />
                                Approve
                            </label>
                        )}
                    </div>
                    <div className='col-12 text-end'>
                        Actual Enrollment : <b> {ActualEnrollment}</b>
                    </div>
                </div>
                <div className="greyBox p-3 ">
                    <div className='data-table-container' ref={tableWrapperRef}>
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    <th scope="col">
                                        {ParentalTabs.Expired == "" && (
                                            PurchasedGridData.length > 0 && PurchasedGridData.some(item => ((item?.student_status == 2 && item?.refund_status == 0) || item.record_type == 1)) && (
                                                <>
                                                    <input className='form-check-input' name="allselect" type="checkbox"
                                                        checked={isAllSelected}
                                                        onChange={handleSelectAll} />
                                                </>
                                            )
                                        )}
                                    </th>
                                    {columnNames?.map((item) => {
                                        let columnName = item.replace(/_/g, ' ');
                                        const transformedName = columnName == "student num" ? "User ID" : transformNameOfCol(columnName);
                                        if (!transformedName) return null;
                                        return (
                                            <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                                {CamelCaseWithSpaces(transformedName)}
                                                <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                            </th>
                                        );
                                    })}

                                    <th scope="col" className={`fw-600 ${ParentalTabs.Expired != "active" ? isOverflowing ? 'sticky-action' : '' : ''}`}>
                                        {ParentalTabs.Expired != "active" ? "Action" : ""}
                                        <img src="/images/EditHeaderIcon.svg" className="cursor-pointer ps-2 pe-5" title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} />
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                {PurchasedGridData.length != 0 ?
                                    PurchasedGridData.map((item, i) => {
                                        return <tr key={i} className={`OddEvenClass tableBorderHide`}>
                                            <td className='py-12'>
                                                {ParentalTabs.Expired == "" && (
                                                    ((item?.student_status == 2 && item?.refund_status == 0) || item.record_type == 1) && (
                                                        <input
                                                            className='form-check-input'
                                                            type="checkbox"
                                                            checked={selectedIds.includes(item?.student_id)}
                                                            onChange={(e) => handleCheckboxForApprove(e, item?.student_id)}
                                                        />
                                                    )
                                                )}
                                            </td>
                                            {columnNames?.map(header => (
                                                <td className="py-12" key={header} >
                                                    {renderContentForColumn(header, item)}
                                                </td>
                                            ))}
                                            <td scope="col" className={`py-12 d-flex ${isOverflowing ? 'sticky-action' : ''}`}>
                                                {ParentalTabs.Coverage == "active" && (
                                                    <>

                                                        <CustomFontAwesomeIcon icon={faFileInvoiceDollar} style={{ height: '20px' }} className=" px-1 cursor-pointer" title="Preview Stripe Receipt"
                                                            onClick={(e) => downloadreceipt(item.receipt_url)} />
                                                        <img src="/images/previewpdficon.svg" className="cursor-pointer px-1" title={`Preview ${dcc_module_text}`} height='20px'
                                                            onClick={(e) => saveAs(item.enrollment_pdf)} />
                                                    </>
                                                )}

                                                {ParentalTabs.Coverage == "active" && (

                                                    ParentalTabs.Expired == "" && (
                                                        ((item?.student_status == 2 && item?.refund_status == 0) || item?.record_type == 1) ? (
                                                            <CustomFontAwesomeIcon icon={faThumbsUp} className="cursor-pointer px-1" title={`Approve ${student}`} style={{ height: '20px' }}
                                                                onClick={(e) => { handleApproveButtonClick(item?.student_id); GetStudentData(item?.student_id); setallocatedEnrollmentID(item?.id) }} />
                                                        ) : item?.refund_status == 0 ? (
                                                            <CustomFontAwesomeIcon icon={faHandHoldingDollar} className="cursor-pointer px-1" title="Refund" style={{ height: '20px' }}
                                                                onClick={(e) => { setStudentIdForRefund(item?.student_id); setRefundPopup(true) }} />
                                                        ) : <>-</>
                                                    )

                                                )}
                                                {ParentalTabs.Uncovered == "active" && (
                                                    ((item?.student_status == 2 && item?.refund_status == 0) || item?.record_type == 1) ? (
                                                        <CustomFontAwesomeIcon icon={faThumbsUp} className="cursor-pointer px-1" title={`Approve ${student}`} style={{ height: '20px' }}
                                                            onClick={(e) => { handleApproveButtonClick(item?.student_id); GetStudentData(item?.student_id); setallocatedEnrollmentID(item?.id) }} />
                                                    )
                                                        :
                                                        <>-</>)}
                                            </td>
                                        </tr>
                                    })
                                    :
                                    <tr className="text-center">
                                        <td colSpan={15}>No Record Found</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {showPagination && (
                    <Pagination
                        activePage={currentPage}
                        itemsCountPerPage={LimitForPagination}
                        totalItemsCount={ActualEnrollment}
                        pageRangeDisplayed={15}
                        onChange={(e) => setCurrentPage(e)}
                        color="primary"
                        lastPageText=""
                        firstPageText=""
                        itemClassFirst="MasterClass"
                        itemClassPrev="MasterClass"
                        itemClassNext="MasterClass"
                        itemClassLast="MasterClass"
                        hideFirstLastPages={true} />
                )}

            </div>
            {CustomizationModal && <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={'Purchases'} tabFlag={44} GetCall={() => ApiGetHeaders(44, setColumnNames)} />}
            {ApproveRejectModal &&
                <Popup isshow={ApproveRejectModal} size={"lg"} title={`Approve ${student}`}
                    closePopup={(e) => { setApproveRejectModal(false) }} modalBody={modalbody}
                    visibleSaveBtn={true} btnText={"Verify & Approve"} handleSave={() => verifyStudentNum()}
                    extraBtn={true} ExtraText={"Don't Approve"}
                    handleSaveForExtra={() => ApproveorRejectPurchasesCall(2, 2, radioBtnFlag)} />
            }
            {ApproveRejectAlert &&
                <AlertPopup isshow={ApproveRejectAlert} img={'/images/greenInfo.svg'}
                    headingtext={`Approving multiple ${student}s may result in wrong information being put into ${secondary_text}. Please double check information before proceeding, or approve individually. Do you want to approve it?`} text={''}
                    cancelcall={(e) => { setApproveRejectAlert(false) }}
                    canceltext={"Cancel"} successtext={"Yes"} successcall={() => ApproveorRejectPurchasesCall(1, null, radioBtnFlag)} btntype={'SaveBtn'} />
            }
            {RefundPopup &&
                <AlertPopup isshow={RefundPopup} img={'/images/greenInfo.svg'}
                    headingtext={`Are you sure you want to refund the ${student} for this club? If you proceed with the refund, the club will be revoked. Do you wish to continue?`} text={''}
                    cancelcall={(e) => { setRefundPopup(false) }}
                    canceltext={"Cancel"} successtext={"Yes"} successcall={() => funcRefund()} btntype={'SaveBtn'} />
            }
        </React.Fragment>

    )
}


export default CoveragePurchased

